/* Project Import will be here */
import * as actions from '../actions/login.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    user: {
        loggedIn: false,
        deviceId: null,
        deviceEmpID:'',
        employeeNumber: '',
        employeeId: '',
        empFullName: '',
        accessToken: null
    }
};
/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {

        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    loggedIn: true,                   
                    employeeId: action.employeeId,
                    empFullName: action.empFullName,
                    employeeNumber: action.employeeNumber,
                    deviceId: action.deviceId,
                    deviceEmpID: action.deviceEmpID,
                    accessToken: action.accessToken                   
                }
            };

        case actions.LOGOUT:
            return {
                ...state,
                user: {
                    ...state.user,
                    loggedIn: false,
                    employeeId: null,
                    employeeNumber: '',
                    empFullName: '',
                    deviceId: null,
                    deviceEmpID:'',
                    accessToken: null
                }
            };

        default:
            return state;
    }
}